import { render, staticRenderFns } from "./UpdateFacilityDetails.vue?vue&type=template&id=c3e562c8&"
import script from "./UpdateFacilityDetails.vue?vue&type=script&lang=js&"
export * from "./UpdateFacilityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports